/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './icon.module.css';
/** icon used by DropdownTrigger */

var Icon = function Icon(_ref) {
  var className = _ref.className;
  return React.createElement("svg", {
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    className: styles['arrow-bottom'],
    d: "M8.00301319,11 C8.24595906,10.9997055 8.48834342,10.9057706 8.67367743,10.7190848 L12.7237734,6.63944944 C13.0906148,6.2699325 13.094203,5.65808188 12.7217707,5.28293319 C12.3467418,4.90516903 11.7464028,4.90688131 11.3750766,5.28091586 L8.00133173,8.67926714 L4.62757867,5.28090757 C4.26073729,4.91139063 3.6533169,4.90777621 3.28088456,5.2829249 C2.90585568,5.66068905 2.90755556,6.2654066 3.27888183,6.63944115 L7.3289778,10.7190765 C7.51206863,10.9035027 7.75508808,10.996782 7.99891041,10.9973155 L8.00301319,11 Z"
  }));
};

Icon.displayName = 'Icon';
Icon.propTypes = {
  className: PropTypes.string
};
Icon.defaultProps = {};
export default Icon;